import {
    GET_ACCOUNT_ITEM_RATES, ACCOUNT_ITEM_RATE_REQUEST, CREATE_ACCOUNT_ITEM_RATE, UPDATE_ACCOUNT_ITEM_RATE, ACCOUNT_ITEM_RATE_REQUEST_FAILURE 
} from "../types/account-item-rate-types";

const initialState = {
  accountItemRate: [],
  loading: false,
  error: null,
};

const accountItemRateReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACCOUNT_ITEM_RATE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_ACCOUNT_ITEM_RATES: {
      return {
        ...state,
        accountItemRate: [...action.payload],
        loading: false,
        error: null
      }
    }
    
    case CREATE_ACCOUNT_ITEM_RATE: {
      return {
        ...state,
        accountItemRate: [action.payload, ...state.accountItemRate],
        loading: false,
        error: null
      };
    }
    case UPDATE_ACCOUNT_ITEM_RATE: {
      const accountItemRateData = state.accountItemRate.slice(0);
      const uIndex = accountItemRateData.findIndex((data) => data.id === action.payload.id);
      accountItemRateData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        accountItemRate: [ ...accountItemRateData ],
        loading: false,
        error: null
      };
    }
    case ACCOUNT_ITEM_RATE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default accountItemRateReducer;
